
const initialState = {
  companies: { data: [], count: 0 },
  selectedCompany: { data: null },
  loading: false,
  error: null
};

const companyReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_COMPANIES':
      return {
        ...state,
        companies: {
          data: action.data?.data?.data || action.data?.data || [],
          count: action.data?.data?.count || action.data?.count || 0
        }
      };
    case 'GET_COMPANY_BY_ID':
      return {
        ...state,
        selectedCompany: { data: action.data },
        loading: false,
        error: null
      };
    case 'UPDATE_COMPANY_BY_ADMIN':
      return {
        ...state,
        selectedCompany: { data: action.data },
        loading: false,
        error: null
      };
    case 'COMPANY_LOADING':
      return {
        ...state,
        loading: true,
        error: null
      };
    case 'COMPANY_ERROR':
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case 'CLEAR_COMPANY_DATA':
      return {
        ...state,
        selectedCompany: { data: null },
        error: null
      };
    default:
      return state;
  }
};

export default companyReducer;

